




























































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IReservation from "@/interfaces/IReservation";
import {AxiosStatic} from "axios";
import dateUtils from '@/utils/dateUtils';
import IResource from "@/interfaces/IResource";
import MailAttachment from '@/components/MailAttachment.vue';

@Component({
	components: {MailAttachment}
})
export default class ConfirmReservationModal extends Vue {
	@Prop({
		required: true,
		type: Number
	})
	public id!: number;

	@Prop({
		required: false,
		type: Object,
		default: null
	})
	public reservation!: IReservation;

	@Prop({
		required: false,
		type: Function
	})
	public callback!: Function;

	public notify_user: boolean = true;
	public show_error: boolean = false;
	public isConfirming: boolean = false;
	private $http!: AxiosStatic;
	public defaultConfirmationText: string = "Wir freuen uns, deine Reservation zu bestätigen:";
	public newConfirmationEmailText: string = '';
	public sendDefaultAttachment: boolean = true;

	public attachments: { filename: string, filesize: number, content: any }[] = [];
	public showInvalidAttachmentSize: boolean = false;

	public $refs!: {
		confirmReservationModal: any,
		attachment_uploader: HTMLInputElement;
	};

	get dt() {
		return dateUtils;
	}

	get resource(): IResource | null {
		if (this.$store.state.resources) {
			let filtered = this.$store.state.resources.filter((r: IResource) => r.id == this.reservation.resource_id);
			if (filtered.length > 0) {
				return filtered[0];
			}
		}
		return null;
	}

	@Watch('resource', { immediate: true })
	public watchResource() {
		if (this.resource && this.newConfirmationEmailText == '') {
			if (this.resource.confirmation_email_text == null) {
				this.newConfirmationEmailText = this.defaultConfirmationText;
			} else {
				this.newConfirmationEmailText = this.resource.confirmation_email_text;
			}
		}
	}

	public mounted() {
		this.$root.$on('bv::modal::hidden', (bvEvent: any, modalId: string) => {
			if (modalId === 'confirmReservationModal') {
				this.show_error = false;
				this.sendDefaultAttachment = true;
				this.showInvalidAttachmentSize = false;
				this.attachments = [];
			}
		})
	}

	public open() {
		this.$refs['confirmReservationModal'].show()
	}

	public close() {
		this.$refs['confirmReservationModal'].hide()
	}

	public checkAttachment(): void {
		if (this.$refs.attachment_uploader && this.$refs.attachment_uploader.files && this.$refs.attachment_uploader.files.length > 0) {
			if (this.$refs.attachment_uploader.files[0].size > 1024*1024) {
				this.showInvalidAttachmentSize = true;
				return;
			}

			this.showInvalidAttachmentSize = false;
			let reader = new FileReader();
			reader.onload = (e: any) => {
				if (this.$refs.attachment_uploader && this.$refs.attachment_uploader.files && this.$refs.attachment_uploader.files.length > 0) {
					this.attachments.push({
						filename: this.$refs.attachment_uploader.files[0].name,
						filesize: this.$refs.attachment_uploader.files[0].size,
						content: e.target.result
					});
				}
			};
			reader.readAsDataURL(this.$refs.attachment_uploader.files[0]);
		}
	}

	public deleteAttachment(index: number): void {
		this.attachments.splice(index, 1);
	}

	public confirmReservation() {
		this.show_error = false;
		this.isConfirming = true;
		let url = '/private/reservation/' + this.id + '/confirm';
		let data = {
			notify_user: this.notify_user,
			confirmationMailText: this.newConfirmationEmailText,
			sendDefaultAttachment: this.sendDefaultAttachment,
			attachments: this.attachments
		};
		this.$http.post(url, data).then(() => {
			this.close();
			if (this.callback && typeof this.callback === 'function') {
				this.callback();
			}
		}).catch(() => {
			this.show_error = true;
		}).finally(() => {
			this.isConfirming = false;
		});
		return true;
	}

}
